export default {
  deals: "Angebote",
};
